import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { StockUnionType } from 'types/stock'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getDefaultBreadTypes } from 'reducks/auth/selectors'

const useBreadTypeFilter = (initialState?: StockUnionType[]) => {
  const defaultBreadTypes = useSelector((state: State) => getDefaultBreadTypes(state))
  const [breadTypes, setBreadTypes] = useState<StockUnionType[]>(initialState || [])
  const isAllBreadTypesSelected =
    breadTypes.includes('daily') && breadTypes.includes('preorder') && breadTypes.includes('delivery')

  const handleBreadTypes = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const id = event.target.id as StockUnionType
      setBreadTypes((prevState) => {
        if (isAllBreadTypesSelected) {
          return [id]
        } else if (prevState.includes(id)) {
          return [...prevState.filter((type) => type !== id)]
        } else {
          return [...prevState, id]
        }
      })
      return
    },
    [setBreadTypes, isAllBreadTypesSelected]
  )

  const selectAllBreadTypes = useCallback(() => {
    setBreadTypes(['daily', 'preorder', 'delivery'])
  }, [setBreadTypes])

  useEffect(() => {
    // initialStateが存在する場合は、初期値を設定しない
    if (initialState && initialState.length > 0) return
    setBreadTypes([...defaultBreadTypes])
  }, [defaultBreadTypes])

  return {
    breadTypes,
    handleBreadTypes,
    isAllBreadTypesSelected,
    selectAllBreadTypes,
  }
}

export default useBreadTypeFilter
